export default {
    unknown: "Unknown",
    failed: "Action failed",
    success: "Action was successful",
    trustHubInfo: "TrustHub is built with the most robust and advanced technology for security and is one of the most secure place where to manage data with a completely GDPR compliance environment.",
    onboard: "Onboard",
    authentication: "Authentication",
    restore: "Restore",
    spanish: "Spanish",
    english: "English",
    italian: "Italian",

    loginAuthenticateWith: "with Username & Password",
    loginWelcomeBack: "Welcome back, please login to your account providing your",
    loginWelcomeBackCredentials: "Credentials",
    loginUsername: "Username",
    loginUsernameRequired: "Username is required.",
    loginPassword: "Password",
    loginPasswordRequired: "Password is required.",
    loginForgotPassword: "Forgot Password",
    loginRememberMe: "Remember me",
    loginAgree: "By continuing you agree the TrustHub",
    loginAgreeService: "service agreement",
    loginAgreeAnd: "and",
    loginAgreePolicy: "privacy policy",
    loginSubmit: "Login",
    loginOrChooseDiffAuthOption: "Or choose a different Authentication option from the lateral menu.",
    loginSubscribeTrial: "Subscribe for a free trial",
    loginWarningAcceptLicense: "You need to accept the license and terms first",
    loginSucceeded: "Logged in",
    loginReCaptchaCheck: "Please check I'm not a robot",

    dashboard: "Dashboard",
    candidate: "Candidate",
    employee: "Employee",
    employer: "Employer",
    contract: "Contract",
    recruit: "Recruit",
    settings: "Settings",
    help: "Help",

    authenticate: "Authenticate",
    sessionLost: "SessionLost",
    search: "Search",
    clear: "Clear",
    newCandidate: "New candidate",
    newEmployer: "New employer",
    newContract: "New contract",
    continue: "Continue",
    resident: "Resident",
    residentErrorMessage: "Please type Resident information",
    street: "Street",
    zipCode: "Zip Code",
    domicile: "Domicile",
    infDomicile: "To be filled in if different from the residence",
    infOtherwiseDomicile: "Otherwise it should be filled in automatically",
    preference: "Preference",
    geographicalAvailability: "Geographical availability",
    withinKmFromHome: "Within km from home",
    email: "Email",
    mobile: "Mobile",
    streetErrorMessage: "Please type Street information",
    provinceErrorMessage: "Please select a Province",
    zipCodeErrorMessage: "Please type Zip Code information",
    domicileErrorMessage: "Indique un domicilio valido",
    emailErrorMessage: "Please type an Email",
    invalidEmailErrorMsg: "Please type a valid Email",
    mobileErrorMessage: "Please type a Mobile number grander than 3 digits",
    invalidMobileErrorMsg: "Please type a valid Mobile number",
    invalidWordOnlyErrorMsg: "Please type letters and spaces only",
    invalidAlphanumericErrorMsg: "Please type a valid alphanumeric value",
    invalidDateErrorMsg: "Please type a valid date",
    invalidPositiveNumberErrorMsg: "Please type a valid positive number",

    //*-----------------------* Steps name, description *-----------------------*

    registryStepName: "Registry",
    personalDataText: "Personal Data",
    personalDataDescriptionText: "Personal Data description",

    residenceText: "Residence",
    residenceDescriptionText: "Residence description",

    contactsText: "Contacts",
    contactsDescriptionText: "Contacts description",

    tasksStepName: "Tasks",
    employeeSectionAvailabilityOfTasksRequiredText: "Availability of tasks required (Cross even more duties)",
    employeeSectionAvailabilityOfTasksRequiredDescriptionText: "Availability of tasks required description",

    contractStepName: "Contract",
    contractualTypeStepText: "Contractual type",
    contractualTypeDescriptionText: "Contractual Type description",

    contractAgreementDescriptionText: "Tipologia accordo contratturale",

    availabilityStepName: "Availability",
    availabilityToWorkText: "Availability to work",
    availabilityToWorkDescriptionText: "Availability To Work description",

    otherStepName: "Other",
    otherInformationStepName: "Other information",
    otherRequestStepName: "Altre richieste",
    otherInformationText: "Other information",
    otherInformationStepDescriptionText: "Other Information description",

    otherInformationDescriptionText: "Other information",

    experiencesStepName: "Experiences",
    workExperiences: "Work experiences",
    workExperiencesDescription: "Work experiences description",

    languagesStepName: "Languages",
    knowledgeItalianLanguage: "Conoscenza lingua italiana",
    knowledgeItalianLanguageDescription: "Conoscenza della descrizione della lingua italiana",

    employerKnowledgeItalianLanguageDescription: "Livello conoscienza lingua italiana",

    trainingStepName: "Training",
    houseWorkTrainingText: "Housework training",
    houseWorkTrainingDescriptionText: "Housework training description",

    capacityStepName: "Capacity",
    employeeAvailabilityToUseForToolsText: "Availability to use tools for non self-sufficient people",
    employeeAvailabilityToUseForToolsDescriptionText: "Availability to use tools for non self-sufficient people description",

    otherRequestsStepText: "Other requests",
    otherRequestsStepDescriptionText: "Other Requests description",

    assessmentStepName: "Assessment",
    evaluationByTheOperatorStepText: "Evaluation (By The Operator)",
    evaluationByTheOperatorStepDescriptionText: "Evaluation (By the operator) description",

    applicantStepName: "Applicant",
    applicantDataStepText: "Dati richiedente",
    applicantDataStepDescriptionText: "Dati Richiedente descrizione",

    employerRegistryStepsText: "Employer registry",
    employerRegistryStepDescriptionText: "Employer registry description",

    residencePermitStepName: "Residence permit",
    residencePermitText: "Residence permit - Only for non-eu nationality subjects",
    residencePermitDescriptionText: "Residence Permit description",

    addressStepName: "Address",
    addressOfTheEmployerText: "Address of the employer",
    addressOfTheEmployerDescriptionText: "Address of the employer description",

    workplace: "Workplace",
    workplaceDescription: "Workplace description",

    workplaceAddressDescription: "Workplace address",

    informationStepName: "Information",
    otherInformationForRecruitment: "Other information for recruitment",
    otherInformationForRecruitmentDescription: "Other information for recruitment description",

    homeStepName: "Home",
    houseSheetText: "House sheet",
    houseSheetDescriptionText: "House Sheet description",

    employerSummaryText: "Summary",
    employerSummaryDescriptionText: "Summary description",

    babySisterStepName: "Baby sister",
    familyAsstBabySister: "Family assistant (Baby sister)",
    familyAsstBabySisterDescription: "Family assistant (Baby sister) Description",

    specificTasksStepName: "Specific tasks",
    otherWorksDoChildrenText: "Other works to do with children",
    otherWorksDoChildrenDescriptionText: "Other works to do with children description",

    requirementsStepName: "Requirements",
    requirementsRequired: "Requirements required",
    requirementsRequiredDescription: "Requirements required description",

    tasksRequiredText: "Tasks required",
    tasksRequiredDescriptionText: "Tasks Required description",

    tasksRequiredDescription: "second Tasks Required description",

    limitationsStepName: "Limitations",
    notWantedFeatures: "Not wanted features",
    notWantedFeaturesDescription: "Not Wanted Features description",

    selfSufficiencyStepName: "Self-sufficiency",
    employerSectionCardForNonSelfSufficiencyText: "Card for non self-sufficiency",
    employerSectionCardForNonSelfSufficiencyDescriptionText: "Card for non self-sufficiency description",

    caretakerStepName: "Caretaker",
    familyAsstCare: "Family Assistant (Care)",
    familyAsstCareDescription: "Family Assistant (Care) Description",

    otherWorksDoAssistantText: "Altri Lavori Da Svolgere Con L'assistito",
    otherWorksDoAssistantDescriptionText: "Altre attività da svolgere con L'assistito",

    partsStepName: "Parts",
    selectEmployerAndEmployee: "Select employer and employee",
    selectEmployerAndEmployeeDescription: "Select employer and employee description",

    startOfRelationshipStepName: "Start of relationship",
    requestToStartWorkingRelationship: "Request to start working relationship",
    requestToStartWorkingRelationshipDescription: "Request To Start Working Relationship description",

    timetablesStepName: "Timetables",
    weeklyWorkingHoursText: "Weekly working hours",
    weeklyWorkingHoursDescriptionText: "Weekly Working Hours description",

    restStepName: "Rest",
    weeklyRest: "Weekly rest",
    weeklyRestDescription: "Weekly Rest description",

    remuneration: "Remuneration",
    remunerationDescription: "Remuneration Description",

    deductions: "Deductions",
    deductionsDescription: "Deductions Description",

    privacyStepName: "Privacy",
    privacy: "Upload a privacy file",
    privacyDescription: "Privacy description",

    uploadPhoto: "Upload Photo",
    uploadAPhoto: "Upload a user Photo",
    uploadPhotoDescription: "Upload user Photo description",

    //*--------------------* Fields Name, Required messages *--------------------*
    enterNumber: 'Escribe el número de PIN',
    openApp: '1. Abre la aplicación de',
    googleAuthenticator: 'Autenticador de Google',
    mobileDevice: 'en tu dispositivo móvil.',
    downloadFor: '(Descargar para Android o IOS).',
    writeText: '2. Escribe el',
    pinText: 'PIN',
    nextText: 'a continuación:',

    aliasText: "Alias",
    aliasIsRequiredText: "Campo Nome obbligatorio",

    firstNameText: "First Name",
    firstNameIsRequiredText: "First Name is required",

    lastNameText: "Last Name",
    lastNameRequiredText: "Last Name is required",

    fiscalCodeText: "Fiscal code",
    fiscalCodeIsRequiredText: "Fiscal Code is required",

    birthDateText: "Birth date",
    birthDateIsRequiredText: "Birth date is required",

    placeOfBirthText: "Place Of Birth",
    placeOfBirthIsRequiredText: "Place Of Birth is required",

    cityText: "City",
    cityOfBirthText: "City of Birth",
    cityIsRequiredText: "City is required",

    provinceText: "Province",
    provinceOfBirthText: "Provincia of Birth",
    provinceIsRequiredText: "Province is required",

    countryText: "Country",
    countryIsRequiredText: "Country is required",

    countryOfBirthText: "Country of Birth",
    countryFieldRequired: "The country field is required",

    countryPrefText: "Country preference",
    ueIsRequiredText: "UE is required",

    idDocumentTypeText: "ID document type",
    idDocumentTypeIsRequiredText: "ID document type is required",

    numberText: "Number",
    numberIsRequiredText: "Number is required",

    equippedWithAdrivingLicenseText: "Equipped with a driving license",
    driverLicenseIsRequiredText: "Driver License is required",

    licenseNumberText: "License Number",
    licenseNumberIsRequiredText: "License Number is required",

    expiryText: "Expiry",
    expiryIsRequiredText: "Expiry is required",

    citizenshipText: "Citizenship",
    citizenshipIsRequiredText: "Citizenship is required",

    typeOfCourseIsRequiredText: "Type of course is required",

    durationIsRequiredText: "Duration is required",

    placeIsRequiredText: "Place is required",

    sexText: "Sex",
    sexIsRequiredText: "Sex is required",

    residencePermitNumberText: "Residence permit number",
    residencePermitNumberIsRequiredText: "Residence permit number is required",

    releasedByText: "Released by",
    releasedByIsRequiredText: "Released By is required",

    explanatoryStatementText: "Explanatory Statement",
    explanatoryStatementIsRequiredText: "Explanatory Statement is required",

    otherExplanatoryStatementText: "Other Explanatory Statement",
    otherExplanatoryStatementIsRequiredText: "Other Explanatory Statement is required",

    domesticPartnershipText: "Domestic Partnership",

    timePeriodText: "Time/Period",

    fromText: "From",
    fromTimeIsRequiredText: "From Time is required",

    toText: "To",
    toTimeIsRequiredText: "To Time is required",

    hoursText: "Hours",
    HoursIsRequiredText: "Hours is required",

    workingHoursText: "Working hours",

    dailyHourlyAvailabilityText: "Daily hourly availability",
    dailyHourlyAvailabilityIsRequiredText: "Daily hourly availability is required",

    forReplacementText: "For replacement",

    checkboxRequiredField: "The information is required, select one or more options",
    radioButtonRequiredField: "The information is required, select one option",

    //*--------------------* list options *--------------------*

    undeterminedText: "Undetermined",
    determinedText: "Determined",
    fullTimeText: "Full time",
    partTimeText: "Part time",
    nightPresenceText: "Night presence",
    discontinuousNightPerformanceText: "Discontinuous night performance",
    forReplacementForHolidayReplacementText: "For holiday replacement",
    forReplacementForReplacementInGeneralText: "For replacement in general",

    morningText: "Morning",
    afternoonText: "Afternoon",
    mondayText: "Monday",
    tuesdayText: "Tuesday",
    wednesdayText: "Wednesday",
    thursdayText: "Thursday",
    fridayText: "Friday",
    saturdayText: "Saturday",
    sundayText: "Sunday",

    identityCard: "identity card",
    passport: "passport",
    socialSecurityNumber: "social security number",
    driverLicence: "driver licence",
    nonDichiarato: "Non dichiarato",
    campoObbligatorio: "* Il campo è obbligatorio",

    //*--------------------* others *--------------------*



    //*--------------------* FALTA ORDENAR *--------------------*

    weeklyRestDayText: "Weekly rest day",
    anotherDayText: "Another day",
    specialFoodNeedsText: "Special food needs",
    specialFoodNeedsIsRequiredText: "Special food needs is required",
    inPossessionOfGreenPassText: "In possession of green pass",
    allergicToAnimalsHairText: "Allergic to animal's hair",
    ifYesToWhichText: "If yes to which",
    ifYesToWhichRequiredText: "If yes to which is required",
    smokerText: "Smoker",
    notesAllergiesOrOtherText: "Notes (Allergies Or Other)",
    notesAllergiesOrOtherIsRequiredText: "Notes (Allergies Or Other) is required",
    italianCookingCapacityText: "Italian Cooking Capacity",
    noteText: "Note",
    noteIsRequiredText: "Note is required",
    carText: "Car",
    drivingExperienceText: "Driving experience",
    cityDrivingExperienceText: "City driving experience",
    outSideTheCityText: "Out side the city",
    possibleWorkerRequestsText: "Possible worker requests",
    possibleWorkerRequestsIsRequiredText: "Possible worker requests is required",
    addressText: "Address",
    addressIsRequiredText: "Address is required",
    typeOfHouseText: "Type of house",
    otherTypeOfHouseText: "Other type of house",
    otherTypeOfHouseIsRequiredText: "Other type of house is required",
    apartmentText: "Apartment",
    villaText: "Villa",
    otherText: "Other",
    numberOfRoomsText: "Number of rooms",
    otherNumberOfRoomsText: "Other number of rooms",
    otherNumberOfRoomsIsRequiredText: "Other number of rooms is required",
    numberOfBathroomsText: "Number of bathrooms",
    otherNumberOfBathroomsText: "Other number of bathrooms",
    otherNumberOfBathroomsIsRequiredText: "Other number of bathrooms is required",
    areasOfTheHouseText: "Areas of the house",
    areasOfTheHouseIsRequiredText: "Areas of the house is required",
    teraceText: "Terrace",
    gardenText: "Garden",
    otherAreasOfTheHouseText: "Other Areas Of The House",
    otherAreasOfTheHouseIsRequiredText: "Other Areas Of The House is required",
    animalsText: "Animals",
    inCaseOfCohabitationText: "In case of cohabitation is there an autonomous room for the worker?",
    floorText: "Floor",
    floorIsRequiredText: "Floor is required",
    elevatorText: "Elevator",
    coincideText: "Coincide con la residenza del datore di lavoro",
    coincideContattiText: "Coincide con los contactos del solicitante",
    babySisterText: "Baby-sister",
    wakeUpAndFallAsleepText: "Baby-wake up and fall asleep",
    prepareLunchDinnerAccordingFamilyText: "Prepare lunch and dinner according to the family directions",
    takeThemSchoolOrKindergartenText: "Take them to school or kindergarten and fetch them",
    makeCompanyByDayNightText: "Make him company by day and night",
    helpThemSchoolTasksText: "Help them in school tasks",
    takeThemWalksActivitiesParkText: "Take them for walks, activities in the park",
    accompanyThemSchoolExtraText: "Accompany them to school and extra school activities",
    takeCareOfTheirPersonalText: "Take care of their personal hygiene, dress and undress",
    tripsText: "Trips",
    laundryAndIronText: "Laundry and iron (children\'s clothes)",
    foodPreparationText: "Food preparation for the whole family",
    accommodationArrangementText: "Accommodation arrangement",
    survillanceAdminisrationDrugsText: "Surveillance and / or administration of drugs according to the directions received",
    accompanyThemPickThemAtText: "Accompany them and pick them at sports / recreational meetings / therapies / friends / families / grocery / other",
    helpingThemHouseHoldText: "Helping them with household chores",
    taskJobDutyText: "Task/job/duty",
    taskJobDutyIsRequiredText: "Task/job/duty is required",
    weeklyWorkingHoursNoText: "Weekly working hours N° hours",
    weeklyWorkingHoursNoIsRequiredText: "Weekly working hours N° hours is required",

    totalHoursText: "Total hours",
    morningFromText: "Morning from",
    morningToText: "Morning to",
    aftrnoonFromText: "Aftrnoon from",
    aftrnoonToText: "Aftrnoon to",
    numberOfHoursText: "Number of hours",

    fillInAnotherTimeText: "Fill in another time",

    availibilityToWorkWithText: "Availability to work with",
    menText: "Men",
    womenText: "Women",
    indifferentText: "Indifferent",
    nonSelfInsuficientText: "Non self-Insuficient",
    childrenText: "Children",
    availabilityToMoveWithTheEmployerForShortPeriodsText: "Availability to move with the employer for short periods",
    inTheHolidayPeriodsText: "In the holiday periods",

    periodPreferenceForHolidayEnjoymentText: "Period preference for holiday enjoyment",
    availabilityAtAdditionalExtraOrdinaryHoursDuringWeekText: "Availability at additional/extraordinary ordinary hours during the week",
    availabilityForExtraOrdinaryHolidayText: "Availability for extraordinary holidays",
    employeeOtherInformationRequireTrainingDiplomaText: "For the sole purpose of preforming the task of assistent to non self-sufficient person, the employer requests the professional training diploma of 500 hours (art. 9 CCNL - Notes in the minutes, LETT.C)",

    birthOfPlaceText: "Birth of place",
    trainingsText: "Trainings",
    houseworkTrainingAttendedTrainingCoursesText: "Have you attended training courses relating to Household work or Family care?",
    forWathTasksText: "For what tasks",
    DurationMonthsText: "Duration (Months)",
    addTrainingCourseText: "Add training course",
    obtainingUni11766CertText: "Has obtained UNI 11766 certification",
    dateIsRequiredText: "Date is required",

    maidText: "Maid",
    baysterText: "Baby sister",
    careTakerText: "Caretaker",
    typeOfCourseText: "Type of course",
    durationText: "Duration",
    placeText: "Place",
    ifYesIndicateWhichText: "If YES, indicate which:",

    notesText: "Notes",
    notesIsRequiredText: "Notes is required",
    evaluation1To5Text: "Evaluation 1/5",
    evaluation1To5IsRequiredText: "Evaluation 1/5 is required",

    natureOfTheEmployerText: "Nature of the employer",
    physicalPersonText: "Physical person",
    religiousCommunityText: "Religious community",
    boardingSchoolText: "Boarding School",
    secularPriestOfCatholicWorshipText: "Secular priest of catholic worship",
    professionText: "Profession",
    professionIsRequiredText: "Profession is required",

    allLevels: "All levels",
    exclusiveInChargeOfHouseCleaning: "Exclusive in charge of house cleaning",
    cookingAjdCookSupport: "Cooking aid - cook support",
    assistantToPets: "Assistant to pets",
    commonWorker: "Common worker",
    generalMultifunctionalCollaborator: "General multifunctional collaborator (colf)",
    ironingManager: "Ironing manager",
    gardener: "Gardener",
    driver: "Driver",
    familyAssistantAssistingSelfSufficientPeople: "Family assistant assisting self sufficient people",
    cook: "Cook",

    workerExclusivelyInTheLaundry: "Worker exclusively in the laundry",
    stableman: "Stableman",
    cleaningAndWateringTheGreenAreas: "Cleaning and watering the green areas",
    companyOfficer: "Company officer",
    guardianOfPrivateHouse: "Guardian of private house",
    waiter: "Waiter",
    qualifiedWorker: "Qualified worker",
    roomCleaner: "Room cleaner",
    familyAssistantAssistingChildren: "Family assistant assisting children (baby sister)",
    familyAssistantAssistingNonSelfSufficientPeopleNotTrained: "Family assistant assisting non self sufficient people not trained",

    administratorOfFamilyAssets: "Administrator of family assets",
    housekeeper: "Housekeeper",
    headGardener: "Head gardener",
    familyAssistantAssistingNonSelfSufficientPeopleTrained: "Family assistant assisting non self sufficient people (trained)",
    trainedFamilyAssistantEducator: "Trained family assistant educator(colf)",

    residencePermitText: "Residence permit - Only for non-eu nationality subjects",
    residencePermitDescriptionText: "Residence Permit description",
    nationalityText: "Nationality",
    typeOfPermitText: "Type of permit",
    dateOfRequestText: "Date of request",
    reasonForPermitText: "Reason for permit",
    permitNumberText: "Permit Number",
    policeHeadquartersOfText: "Police headquarters of",

    fractionationText: "Fractionation",
    townshipText: "Township",

    butler: "Butler",
    chiefChef: "Chief chef",
    instructor: "Instructor",
    houseManager: "House Manager",
    domicileDifferentToResident: "Domicile different to resident",
    selectIfDomicileDifferentToResident: "Select if domicile is different to resident",

    employeeCreatedSuccessfullyText: "Employee was created successfully",
    employerCreatedSuccessfullyText: "Employer was created successfully",
    create: "Create",
    yesText: "Yes",
    noText: "No",
    sexFemaleText: "Female",
    sexMaleText: "Male",
    sexNotPreferenceText: "I have no preference",
    countryUEText: "UE",
    countryUEExtraText: "Extra UE",
    alreadyAsstContractedText: "There are other assistants already contracted",
    personalCarePrefSexText: "Personal care preferences sex",
    agePreferenceRangeText: "Age Preference (Range)",

    datePattern: "/^[0-3]\d\/[0-1]\d\/-?[\d]+$/",
    dateFormat: "YYYY/MM/DD",
    dateFormatMask: "####/##/##",
    dateMondayShort: "Mon",
    dateTuesdayShort: "Tue",
    dateWednesdayShort: "Wed",
    dateThursdayShort: "Thu",
    dateFridayShort: "Fri",
    dateSaturdayShort: "Sat",
    dateSundayShort: "Sun",

    dateJanuary: "January",
    dateJanuaryShort: "Jan",
    dateFebruary: "February",
    dateFebruaryShort: "Feb",
    dateMarch: "March",
    dateMarchShort: "Mar",
    dateApril: "April",
    dateAprilShort: "Apr",
    dateMay: "May",
    dateMayShort: "May",
    dateJune: "June",
    dateJuneShort: "Jun",
    dateJuly: "July",
    dateJulyShort: "Jul",
    dateAugust: "August",
    dateAugustShort: "Aug",
    dateSeptember: "September",
    dateSeptemberShort: "Sep",
    dateOctober: "October",
    dateOctoverShort: "Oct",
    dateNovember: "November",
    dateNovemberShort: "Nov",
    dateDecember: "December",
    dateDecemberShort: "Dec",

    requiredField: "This information is required",
    year: "Year",
    qualification: "Qualification",
    level: "Level",
    withDomesticPartnership: "With domestic partnership",
    date: "Date",
    reportStartDate: "Report start date",
    reportEndDate: "Report end date",
    employerReference: "Employer reference",
    nameSurname: "Name surname",
    telephoneNumber: "Telephone number",
    mail: "Mail",
    startReport: "Start report",
    endReport: "End report",
    add: "Add",
    editButton: "Edit",
    reference: "Reference",
    partnership: "Partnership",
    assistanceExperiencesNonSelfSufficientPersons: "Assistance experiences for non self-sufficient persons",
    characteristicsPreviousExperiences: "Characteristics of previous experiences",
    elderly: "Elderly",
    withDisabilities: "With disabilities",

    writtenLevel: "Written Level",
    spokenLevel: "Spoken Level",
    otherLanguages: "Other Languages",
    enough: "Enough",
    good: "Good",
    great: "Great",

    selectAnOption: "Select an option",
    noResults: "No results",
    close: "Close",
    cancel: "Cancel",
    addWorkExperience: "Add work experience",
    none: "None",

    townshipErrorMessage: "Township is required",
    fractionationErrorMessage: "Fractionation is required",
    coincidesWithTheEmployersResidence: "Coincides with the employer's residence",
    coincidesWithTheEmployersResidenceErrorMessage: "Coincides with the employer's residence is required",

    isTheEmployerOwnerTheHouse: "Is the employer owner of the house?",
    inCasesAssistanceThePersonTheEmployerIs: "In cases of assistance to the person, the employer is",
    isCivilInvalidOrCivilBlind: "Is the employer great invalid to war or to work or mutiled or civil invalid or civil blind? (With Ass. of Accomp. law 18/80, 508/88)",
    parent: "Parent",
    tutor: "Tutor",
    relative: "Relative",
    son: "Son",
    spouse: "Coniuge",

    selfSufficientText: "Self-sufficient",
    disabledPersonText: "Disabled person",
    disabledPersonExplanation: "If you fill in the card, it is not self-sufficient",
    familyAsstNonSelfSuffPeopleNonFormedCareerCoverageDaysOfRestText: "Family assistant assisting non self-sufficient people (Not trained career) (Coverage days of rest)",
    familyAsstNonSelfSuffPeopleFormedCareerCoverageDaysOfRestText: "Family assistant assisting non self-sufficient people (Formed career) (Coverage days of rest)",
    familyAsstEducatorRestDayCoverageText: "Home manager (Rest day coverage)",
    familyAsstPersonNonAutosufficientiFormatoText: "Trained family assistant educator (Rest day coverage)",

    childSex: "Child sex",
    assistedSex: "Assisted sex",
    ageChild: "Age of child",
    ageAssisted: "Age assisted",
    ageChildErrorMessage: "Age of Child field is required",
    ageAssistedErrorMessage: "Age assisted field is required",
    sportsActivities: "Sports Activities",
    recreationalActivities: "Recreational Activities",
    allergies: "Allergies",
    specialFeeding: "Special Feeding",
    eatAlone: "Eat Alone",
    singleText: "Single",
    marriedText: "Married",
    widowerText: "Widower",
    divorcedText: "Divorced",
    maritalStatusText: "Marital Status",

    educationalQualification: "Educational qualification",
    noPreference: "No preference",
    graduation: "Graduation",
    middleSchoolDiploma: "Middle school diploma",
    higherLicense: "Higher license",
    sexOfTheBabySister: "Sex of the baby sister",
    woman: "Woman",
    man: "Man",
    ageRange: "Age range",

    secondLanguage: "Second language",
    indispensable: "Indispensable",
    optional: "Optional",
    language: "Language",
    languageIsRequired: "Language is required",

    portuguese: "Portuguese",
    polish: "Polish",

    toBeFilledInOnlyInCaseOfNonSelfSufficiency: "To Be Filled In Only In Case Of Non Self-Sufficiency",
    internalMobilityInTheHome: "Internal Mobility In The Home",
    tripodStick: "Tripod Stick",
    electricWheelchair: "Electric Wheelchair",
    manualWheelchair: "Manual Wheelchair",
    crutches: "Crutches",
    walker: "Walker",
    walkingFrame: "Walking Frame",

    sittingOrBedMobility: "Sitting Or Bed Mobility",
    electricArmchair: "Electric Armchair",
    lifter: "Lifter",
    orthopedicBed: "Orthopedic Bed",

    movesAloneInTheBed: "Moves Alone In The Bed",
    externalMobility: "External Mobility",
    personalHygiene: "Personal Hygiene",
    notSelfSufficient: "Not Self-Sufficient",
    nutrition: "Nutrition",
    cognitiveDeficits: "Cognitive Deficits",
    communicationOfThePatient: "Communication Of The Patient",
    abilityToExpressPreferences: "Ability To Express Preferences",
    diseases: "Diseases",
    specialTherapies: "Special Therapies",

    trialPeriod: "Trial period",
    startingWorkRelationship: "Starting Work Relationship",
    termOfEmploymentRelationship: "Term of employment relationship (If for a fixed period)",
    nameLastName: "Name/Lastname",
    postalCode: "Postal Code",

    indicateTheDay: "Indicate the day",
    selectDay: "Select Day",
    sundayArt: "Sunday (Except Art. 14, Paragraph 4 - Ccnl)",
    holyDatePatron: "Holy date patron",

    hourlyIfTheRelationshipIsNotCoLive: "Hourly if the relationship is not Co-Live",
    monthlyIfTheRelationshipIsCoLive: "Monthly if the relationship is Co-Live",
    grossRemunerationAmount: "Gross remuneration amount",
    possibleSuperminimum: "Possible superminimum",
    howMuch: "How Much",
    possibleIndemnity: "Possible indemnity",
    table: "Table",
    monthlyAdvanceThirteenthInstallment: "Monthly advance thirteenth installment",
    availabilityToPayAMaximum70Annual: "Availability to pay a maximum 70% annual",
    percentage: "Percentage",
    termsOfPayment: "Terms of payment",
    transfer: "Transfer",
    cash: "Cash",
    check: "Check",

    employerPayboxEveryMonth: "The contributions are paid quarterly by the employer. do you want to keep the inps / cassacolf fee of its competence in the employer's paybox every month?",
    presenceOfCamerasInTheHome: "Presence of cameras in the home",
    presenceOfAnimalsInTheHouse: "Presence of animals in the house",
    availabilityInExtraordinaryHolidays: "Availability in extraordinary holidays",
    theTaskOfAssistantToNonSelfSufficientPersonMsg: "For the sole purpose of performing the task of assistant to non self-sufficient person, the employer requests the professional training diploma of 500 hours (Art. 9 Ccnl - Notes in the minutes, Lett. C)",
    dsLevelRecruitment: "Ds level recruitment",
    aDiplomaOfTrainingIsRequired: "A diploma of training is required",
    checkAnOption: "Please check an option",
    checkManyOptions: "Please check one or more options",

    enterEmployerFirstLastName: "Enter the employer first and last name",
    enterEmployeeFirstLastName: "Enter the employee first and last name",
    advancedSearch: "Advanced Search",
    save: "Save",
    update: "Update",
    reset: "Reset",
    print: "Print",
    view: "View",
    edit: "Edit",
    terminate: "Terminate",

    selectEmployerAndEmployee: "Select employer and employee",
    selectEmployerAndEmployeeDescription: "Select employer and employee description",

    messageForPrintOnEditOperation: "The print option will use the data already stored and not the data being updated. Do you want to continue?",
    invalidDateRangeErrorMsg: "Please enter a valid date range",

    noWorkExperiencesAdded: "No work experiences added",
    noTrainingCourseAdded: "No training course added",
    Unauthorized: "The user is unauthorized",

    selectSection: "Select optional sections",
    selectSectionDescription: "Select optional sections description",
    selectSectionStepName: "Optional sections",

    searchResultFound: "Search results found",
    collapseAll: "Collapse all",
    noEmployerFound: "No employers found",
    searchEmployer: "Search employer",
    notFoundMsg: "No items found",
    items: "Items",
    typeInfoFindEmployers: "Type information to find employer",
    typeInfoFindCandidates: "Type information to find candidates",
    employerSingular: "Employer",
    searchCandidates: "Search candidates",
    noCandidatesFound: "No candidates found",

    formSavedSuccessfully: "Saved form successfully",
    formSaveFailed: "An error ocurred saving the form",
    formUpdatedSuccessfully: "Updated form successfully",
    formUpdatedFailed: "An error ocurred updating the form",
    reportDownloadedSuccessfully: "Downloaded report successfully",
    reportDownloadFailed: "An error ocurred downloading the report",
    idGetFailed: "An error ocurred retrieving the requested Id",
    listGetFailed: "An error ocurred retrieving the requested list",
    reportPrintingProcessing: "The requested report is being processed, please wait ...",
    recordRetrieveProcessing: "The requested record is being processed, please wait ...",

    logOut: "Log out",
    selectEmployerToContinue: "Please select a employer to continue",
    selectCandidatesToContinue: "Please select one or more candidates to continue",

    findCandidatesByFilters: "Find candidates by filters",
    fromDate: "From date",
    toDate: "To date",
    filter: "Filter",
    total: "Total",

    alreadyRecruitedByAnEmployer: "Already recruited by an employer",
    findByCompany: "Find by company",
    findByCompanyAgency: "Find by company and agency",
    loginFailed: "The authentication failed, maybe there are some problems with the serve. Please try again in a few minutes.",

    uploadUserPhoto: "Upload a user photo",
    animalsDescription: "Animals description",
    animalsDescriptionIsRequired: "Animals description is required",
    familyAssistantAssistingSelfSufficientBadante: "Assistente familiare che assiste persone autosufficienti (badante)",
    asstFamilyEducatorFormat: "Trained educator family assistant (rest days coverage)",
    agency: "Agency",
    noDataToShowFor: "No data to show for",
    noDataToShow: "No data to show",
    itemSelected: "Item selected",
    itemsSelected: "Items selected",
    noItemSelected: "No items selected",
    itemsPerPage: "Items per page",
    previousSelection: "Previous selection",
    deleteSelectedItems: "Delete selected items",
    previousSelectionExtra: "Select one or more items to delete form this list",

    recruitSaveSuccessfully: "The recruit saved successfully",
    recruitFailedToSave: "The recruit failed to save",
    candidatesRemovedRecruitSuccess: "Candidates removed successfully to the recruit",
    candidatesFailedRemovedForRecruit: "Candidates failed to remove to the recruit",

    sureDeleteItemsMessage: "Are you sure want to delete the items in your previous selection?",
    delete: "Delete",
    changeEmployer: "Change employer",
    changeEmployee: "Change employee",
    alreadyEmployerHasAContract: "Employer already linked to a contract",

    messageChangeEmployer: "Please create another contract with the new employer. Are You sure to change the Employer?",
    messageChangeEmployee: "Please create another contract with new employer and candidates. Are You sure to change the Employee?",
    uploadFile: "Upload file",
    privacy: "Privacy",
    privacyFile: "Privacy file",
    pleaseSelectJPGImage: "Please, select a JPG image",
    uploadDocuments: "Upload documents",
    uploadDocumentFront: "Upload document image front",
    uploadDocumentBack: "Upload document image back",
    downloadFiles: "Download files",
    documentFiles: "Document files",
    share: "Share",
    shared: "Shared",
    dateOfIssue: "Date of issue",
    dateOfIssueIsRequired: "date of issue si required",

    reliance: "Reliance",
    assistanceMinors: "Assistance for minors dl 8.1.07 n. 5 art 2 c.6",
    waitingCircularOccupations: "Waiting for circular occupations dep. free civ",
    sportActivity: "Sport activity",
    medicalCare: "Medical care",
    minorFamily: "Minor family 14/18",
    minorIntegration: "Minor integration",
    workParticularCasesOfTheTU: "I work particular cases lett. and art. 27 of the TU",
    artisticWorks: "Artistic works",
    seasonalWork: "Seasonal work",
    multiYearSeasonalWorkDpr: "Multi-year seasonal work dpr 394/99",
    subordinateWork: "Subordinate work",
    employmentExpectedEmployment: "Employment - expected employment",
    minorAge: "Minor age",
    volunteerMissionLegislativeDecree: "Volunteer mission Legislative Decree 154/07",
    businessReasonsSelfEmployment: "Business reasons/self-employment",
    reasonsStudy: "Reasons for study",
    familyReasons: "Family reasons",
    humanitarianReasonsArt11: "Humanitarian reasons art. 11 letter c-ter",
    humanitarianReasonsArt18: "Humanitarian reasons art. 18 d.l. 286/98",
    humanitarianReasonsI: "Humanitarian reasons i. 31/07/2005 no. 155",
    permitStayLongPeriod: "Permit of stay ce subj. long period",
    subsidiaryProtection: "Subsidiary protection art. 17 legislative decree 251",
    scientificResearch: "Scientific research",
    requestPoliticalActivity: "Request political asylum-working activity",
    reconStatelessPerson: "Recon. stateless person - Presidential Decree 334/04 art. 1 c. 1 let. c",
    internship: "Internship",
    workingHoliday: "Working holiday",

    authorizeCandidate: "Authorize candidate",
    expiryDate: "Expiry date",
    noAgencies: "No agencies",
    viewDetails: "View details",

    reportUserDeleteProcessing: "The user is deleting, please wait ...",
    reportUserDeleteSuccessfully: "The user was deleted successfully",
    reportContractTerminateSuccessfully: "Contract terminated successfully",
    reportContractTerminateFailed: "Error during contract termination",
    reportUserDeleteFailed: "Failed when try to delete user",
    reportContractTerminateProcessing: "We are closing the selected contract. Please wait...",

    reportContractDeleteProcessing: "The contract is deleting, please wait ...",

    msgAuthorizeSuccessfully: "The candidate was authorize successfully",
    msgEditAuthorizeSuccessfully: "The candidate authorize was edited successfully",
    msgDeleteAuthorizeSuccessfully: "The authorize was delete successfully",

    msgAuthorizeFailed: "Failed to authorize the candidate",
    msgEditAuthorizeFailed: "Failed to edit authorize the candidate",
    msgDeleteAuthorizeFailed: "Failed to delete the authorize",

    sureDeleteCandidateMessage: "Are you sure want to delete the candidate?",
    askMoreInformation: "Ask for information",

    sureDeleteEmployerMessage: "Are you sure want to delete the Employer?",
    sureTerminateEmployerMessage: "Are you sure want to terminate the Employer?",

    contractTerminated: "Contract terminated",
    startDateAndYearDifferent: "The year must be the same as the year of the start date."
}
